import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditableProductRelatedEntry } from 'src/app/cs-buildup/charging-stations-section/cs-setup/editable-cs-setup-section';

@Component({
  selector: 'app-remove-affected-entries-dialog',
  templateUrl: './remove-affected-entries-dialog.component.html',
  styleUrls: ['./remove-affected-entries-dialog.component.scss']
})
export class RemoveAffectedEntriesDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<RemoveAffectedEntriesDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public dialogData: {
      affectedEntries: EditableProductRelatedEntry[] }) { }

  ngOnInit(): void {

  }

  public confirmDeletion(): void {
    this.dialogRef.close(true);
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }
}
